export default __webpack_public_path__ + "static/media/codeclan-graduation-lqMAX.978af97f.jpg";